import { FavouriteType, FavouritesViewModel } from './favourites.model';

export function isFixtureFavourite(favourite: FavouritesViewModel): boolean {
    return favourite.type === FavouriteType.Fixture || favourite.type === FavouriteType.FixtureV2;
}
